<template>
    <div class="fill-height">
        <TabBasic ref="tabBasic" :items="tabs" show-breadcrumbs>
            <template v-slot:header>
                <v-spacer/>
            </template>
        </TabBasic>
    </div>
</template>

<script>
import TabBasic from "@/components/reusable/TabBasic/TabBasic";

export default {
  name: "NotificationBasic",
  components: {TabBasic},
  mounted() {
    window.addEventListener('keyup', this.handleKeyup);
  },
  beforeDestroy() {
    window.removeEventListener('keyup', this.handleKeyup);
  },
  data() {
    return {
      tab: null,
      openAddEditDialog: false,
    };
  },
  computed: {
    isAdmin() {
      return this.$store.getters.isOrganizationAdmin;
    },
    tabs() {
      if (!this.isAdmin) {
        return [];
      }

      return [
        {
          title: this.$t('menu.notifications'),
          to: {
            name: 'sendNotifications'
          }
        },
        {
          title: this.$t('notifications.history'),
          to: {
            name: 'notificationHistory'
          }
        }
      ]
    }
  },
  methods: {
    handleKeyup(e) {
      if (e.key === 'Escape') {
        this.$router.back();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "notification-basic";
</style>